import { Color } from '@coast/schemas';
import { isNil } from 'lodash';
import { Pill } from '@shared/components/pill';
import { CombinedTagsField } from '@shared/data/entity/fields/CombinedTagsField';
import { TagOption, useCombinedTagOptions } from '@shared/util/hooks/useWorkflowTagOptions';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

const MAX_TAGS_TO_SHOW = 10;

interface Props {
  field: CombinedTagsField;
}

export function CombinedTagsCollectionViewField({ field }: Props) {
  const { options } = useCombinedTagOptions(field.componentIds);

  if (field.isEmpty || isNil(options)) {
    return null;
  }

  const tags: (TagOption | undefined)[] = [];

  field.tags.forEach((value, key) => {
    value.forEach(v => tags.push(options.find(o => o.fieldName === key && o.value === v)));
  });

  const tagsToShow = tags.slice(0, MAX_TAGS_TO_SHOW);
  const remainingTagCount = tags.length - MAX_TAGS_TO_SHOW;

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      {tagsToShow.map(option => {
        if (isNil(option)) {
          return null;
        }
        return (
          <Pill
            key={option.id}
            backgroundColor={option.backgroundColor as Color}
            round
            sections={[option.label]}
          />
        );
      })}
      {remainingTagCount > 0 && (
        <Pill backgroundColor="transparent" sections={[`+${remainingTagCount}`]} round noBorder />
      )}
    </CardCollectionViewFieldContainer>
  );
}
